import { createSlice } from '@reduxjs/toolkit'

import { initialState } from 'store/pages/transaction/state'

import { getData } from '../actions/getData'

export const TransactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getData.fulfilled, (state, action) => {
      const transaction = action.payload
      state.transactions[transaction.transactionCode] = transaction
    })
  },
})
